/**
 * @generated SignedSource<<9a1bd61a2fa6d3296a474327c2545c2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type JobEventType = "ACCEPTED" | "ACCEPTED_EXPIRED" | "AGENT_DISCONNECTED" | "AGENT_LOST" | "AGENT_STOPPED" | "ASSIGNED" | "ASSIGNED_EXPIRED" | "BUILD_STEP_UPLOAD_CREATED" | "CANCELATION" | "CANCELED" | "CHANGED" | "EXPIRED" | "FINISHED" | "LIMITED" | "LOG_SIZE_LIMIT_EXCEEDED" | "NOTIFICATION" | "RESERVED" | "RESERVED_EXPIRED" | "RETRIED" | "RETRY_FAILED" | "SCHEDULED" | "STARTED" | "TIMED_OUT" | "UNBLOCKED" | "%future added value";
export type JobStates = "ACCEPTED" | "ASSIGNED" | "BLOCKED" | "BLOCKED_FAILED" | "BROKEN" | "CANCELED" | "CANCELING" | "EXPIRED" | "FINISHED" | "LIMITED" | "LIMITING" | "PENDING" | "RUNNING" | "SCHEDULED" | "SKIPPED" | "TIMED_OUT" | "TIMING_OUT" | "UNBLOCKED" | "UNBLOCKED_FAILED" | "WAITING" | "WAITING_FAILED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type JobActivityTimelineList_job$data = {
  readonly createdAt?: any | null;
  readonly events?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly timestamp: any;
        readonly type: JobEventType;
        readonly uuid: string;
        readonly " $fragmentSpreads": FragmentRefs<"JobEventAcceptedExpired_event" | "JobEventAccepted_event" | "JobEventAgentDisconnected_event" | "JobEventAgentLost_event" | "JobEventAgentStopped_event" | "JobEventAssignedExpired_event" | "JobEventAssigned_event" | "JobEventBuildStepUploadCreated_event" | "JobEventCancelation_event" | "JobEventCanceled_event" | "JobEventChanged_event" | "JobEventExpired_event" | "JobEventFinished_event" | "JobEventJobLogSizeExceeded_event" | "JobEventLimited_event" | "JobEventRetried_event" | "JobEventRetryFailed_event" | "JobEventScheduled_event" | "JobEventStarted_event" | "JobEventTimedOut_event">;
      };
    } | null> | null;
  };
  readonly state?: JobStates;
  readonly uuid?: string;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventCreated_job">;
  readonly " $fragmentType": "JobActivityTimelineList_job";
};
export type JobActivityTimelineList_job$key = {
  readonly " $data"?: JobActivityTimelineList_job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobActivityTimelineList_job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobActivityTimelineList_job",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobEventCreated_job"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 30
            }
          ],
          "concreteType": "JobEventConnection",
          "kind": "LinkedField",
          "name": "events",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "JobEventEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "timestamp",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventLimited_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventFinished_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventRetried_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventScheduled_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAssigned_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAssignedExpired_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventCanceled_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventCancelation_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAccepted_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAcceptedExpired_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventStarted_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventTimedOut_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventChanged_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventBuildStepUploadCreated_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventExpired_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAgentStopped_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAgentDisconnected_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAgentLost_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventJobLogSizeExceeded_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventRetryFailed_event"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "events(first:30)"
        }
      ],
      "type": "JobTypeCommand",
      "abstractKey": null
    }
  ],
  "type": "Job",
  "abstractKey": "__isJob"
};
})();

(node as any).hash = "5ef6774fa90ade72f312371c5945ffe1";

export default node;
